import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(
  theme => ({
    arrow: {
      color: "#247CFF"
    },

    card: {
      alignItems: "center",
      border: "1px solid #E8EAEE",
      borderRadius: theme.shape.borderRadius,
      cursor: "pointer",
      display: "flex",
      height: 72,

      marginBottom: theme.spacing(2),

      opacity: 1,
      position: "relative",
      transition: "opacity 0.3s ease-in-out",
      width: 404
    },
    cardDisabled: {
      cursor: "not-allowed",
      opacity: 0.5
    },
    circularProgress: {
      color: "#247CFF",
      marginLeft: 8
    },
    content: {
      alignItems: "center",
      display: "flex",
      flexGrow: 1,
      justifyContent: "space-between"
    },
    image: {
      height: 32,
      marginRight: theme.spacing(1),
      width: 32
    },
    tag: {
      borderRadius: theme.shape.borderRadius,
      fontSize: 10,
      fontWeight: 700,
      padding: "2px 6px",
      position: "absolute",
      right: theme.spacing(0),
      top: theme.spacing(0)
    },
    tagActive: {
      backgroundColor: "#0030FF",
      color: "#FFFFFF"
    },
    tagBlue: {
      backgroundColor: "#0030FF",
      borderRadius: theme.shape.borderRadius,
      color: "#FFFFFF",
      fontSize: 10,
      fontWeight: 700,
      padding: "2px 6px",
      position: "absolute",
      right: theme.spacing(0),
      top: theme.spacing(0)
    },
    tagDisabled: {
      backgroundColor: "#F1F2F3",
      color: "#8A8D93"
    },
    text: {
      color: "#000000",
      fontSize: 14,
      fontWeight: 400,
      textAlign: "start"
    },
    textContainer: {
      alignItems: "center",
      display: "flex"
    }
  }),
  { name: "CustomCardWithTag" }
);
